// @flow

import moment from 'moment'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  changeMetric,
  fetchPublisherRevenue,
  getCurrentMetric,
  getLoadingState,
  getRevenue,
  getRevenueSpans,
} from '../../../stores/report/revenue'
import LineChart from '../../Charts/LineChart'
import ColorButton from '../../Controls/ColorButton'
import OpinarySelect from '../../Controls/OpinarySelect'
import BouncingLoader from '../../Loader/BouncingLoader'

import type Moment from 'moment'
import OpinaryDatePicker from '../../DatePicker'
import { METRIC_OPTIONS, METRIC_TO_KEY_MAPPING } from './constants'
import MetricTotalBox from './MetricTotalBox'
import { getCurrentUserCustomer } from '../../../stores/currentUser'

type Props = {
  revenue: Object,
  spans: [],
  metric: string,
  isLoading: boolean,
  fetchPublisherRevenue: Object => void,
  changeMetric: string => void,
  currentUserCustomer: Object,
}

type State = {
  startDate: Moment,
  endDate: Moment,
}

class Revenue extends Component<Props, State> {
  state = {
    startDate: moment().subtract(7, 'd'),
    endDate: moment().subtract(1, 'd'),
  }

  fetchRevenue = () =>
    this.props.fetchPublisherRevenue({
      startDate: this.state.startDate.format('YYYY-MM-DD'),
      endDate: this.state.endDate.format('YYYY-MM-DD'),
    })

  handlerSearch = () => this.fetchRevenue()

  handleChangeStart = (date: Moment) => this.setState({ startDate: date })

  handleChangeEnd = (date: Moment) => this.setState({ endDate: date })

  getMetricOptions = () => {
    const { currentUserCustomer } = this.props
    return METRIC_OPTIONS.filter(value => {
      if (
        value.value === 'video_starts' &&
        !currentUserCustomer.displayVideoRevenues
      )
        return null
      return value
    })
  }

  componentDidMount() {
    this.fetchRevenue()
  }
  render() {
    const {
      revenue,
      spans,
      isLoading,
      metric,
      changeMetric,
      currentUserCustomer,
    } = this.props

    const currentMetric = METRIC_OPTIONS.find(value => value.value === metric)

    return !revenue ? (
      <h1> Loading content </h1>
    ) : (
      <section className="w-100">
        <section className="mb4 flex w-100 tc">
          {METRIC_OPTIONS.map(option => {
            if (
              option.value === 'video_starts' &&
              !currentUserCustomer.displayVideoRevenues
            )
              return null

            return (
              <MetricTotalBox
                isLoading={isLoading}
                value={revenue.totals[option.value]}
                label={option.label}
                currency={option.currency}
              />
            )
          })}
        </section>

        <div className="w-100 pl4 h3 bg-near-white flex  items-center">
          <span className="pr2"> Start date:</span>
          <OpinaryDatePicker
            className="h2 bb b--gray w-50 bg-transparent dark-gray flex-auto"
            selected={this.state.startDate}
            selectsStart
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={this.handleChangeStart}
            showToolTip
          />

          <span className="pr2">End date:</span>
          <OpinaryDatePicker
            className="h2 bb b--gray w-50 bg-transparent dark-gray flex-auto"
            selected={this.state.endDate}
            selectsEnd
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={this.handleChangeEnd}
          />

          <ColorButton
            className="z-3"
            colorClass="op-brand"
            borderClass="b--op-brand"
            onClick={this.handlerSearch}
          >
            Select Date
          </ColorButton>
        </div>

        <section className="mb4 flex w-100 tc">
          <div className="bg-white ml-auto mr-auto pa4 flex flex-column justify-center w-100">
            <div className="flex  items-center ">
              <h4>Metric:</h4>
              <OpinarySelect
                className="w-10"
                value={metric}
                options={this.getMetricOptions()}
                onChange={changeMetric}
              />
            </div>
            <div className="mb3 f4">{currentMetric.label}</div>

            {isLoading ? (
              <BouncingLoader color="#000" />
            ) : spans.length > 0 ? (
              <LineChart
                graphData={revenue.spans}
                title={metric}
                k={METRIC_TO_KEY_MAPPING[metric]}
              />
            ) : (
              <p>We couldn't find the data. Please come back later</p>
            )}
          </div>
        </section>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  spans: getRevenueSpans(state),
  revenue: getRevenue(state),
  isLoading: getLoadingState(state),
  metric: getCurrentMetric(state),
  currentUserCustomer: getCurrentUserCustomer(state),
})

const mapDispatchToProps = {
  changeMetric,
  fetchPublisherRevenue,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Revenue)



// WEBPACK FOOTER //
// ./src/components/Pages/Report/revenueReports.js